module.exports = __webpack_public_path__ + "DINNextLTPro-HeavyCondensed.ttf?3cc0d26ef32e04732ec325a5eed7946b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-HeavyCondensed.ttf
// module id = 1429
// module chunks = 0